// extracted by mini-css-extract-plugin
export default {"input":"Pna-z","button":"Qna-z","selected":"Rna-z","unavailable":"Sna-z","image":"Tna-z"};